import { useEffect } from "react";
import { Outlet } from "react-router";
import { startFunnelRecording, stopFunnelRecording } from "@/lib/analytics";

/**
 * Pathless layout route that wraps the inquiry funnel and turns on full
 * session recording for the duration the user is inside it.
 *
 * Globally (see lib/analytics.ts) recording is disabled — nothing outside
 * this boundary is recorded. On mount we start recording; on unmount (the
 * user leaves the funnel) we stop.
 *
 * A single recording spans the whole `/inquiry` flow — exactly the unit we
 * want to watch for the "completed unaided / dropped on which field" question.
 * Text and inputs are masked (analytics init), so typed PII never leaves.
 */
export function InquiryReplayBoundary() {
  useEffect(() => {
    startFunnelRecording();
    return () => {
      stopFunnelRecording();
    };
  }, []);

  return <Outlet />;
}
